(function(){
var helpers = {
  hasAddonRestaurants: function hasAddonRestaurants(model) {
    return model.Results.AddonsRestaurant &&
      model.Results.AddonsRestaurant.Total;
  },
  displayToMiles: function(miles, unit) {
    var distance = Number(miles);

    if (unit === 'km') {
      distance = miles * 0.621371;
    }

    return Number(distance.toFixed(1));
  },
  milesToDisplay: function(miles, unit) {
    var distance = Number(miles);

    if (unit === 'km') {
      distance = miles * 1.60934;
    }

    return Number(distance.toFixed(1));
  },
  getRelatedSearchLabels: function(searches) {
    function joinSemanticList(list, maxLength) {
      if (list.length === 1) {
        return list[0];
      }

      var shortenedList =
        list.length <= maxLength ?
          list :
          list.slice(0, maxLength);

      var exceptLast = shortenedList.slice(0, shortenedList.length - 1);
      var last = shortenedList[shortenedList.length - 1];

      return exceptLast.join(', ') + ' and ' + last;
    }

    return searches && searches.length ? searches.map(function(searchPair){
      var search = searchPair[1];
      var link = search.link || '#';
      var suggestion = '';
      var MAX_CUISINES = 3;
      var MAX_LOCATIONS = 3;

      if (search) {
        var label = search.label;

        var cuisine = label.cuisinePhrase && label.cuisinePhrase.length ?
          joinSemanticList(label.cuisinePhrase, MAX_CUISINES) + ' in ' : '';

        var location = label.nearestLocationName && label.nearestLocationName.length ?
          joinSemanticList(label.nearestLocationName, MAX_LOCATIONS) : 'a nearby restaurant';

        suggestion = cuisine + location;

        link = '/s/?' + link;
        return [suggestion, link];
      }
    }) : [];
  },
  moment: function hooks () {
        return hookCallback.apply(null, arguments);
    }
};
function toPath(value) {
  if (_(value).isArray()) {
    return value;
  }
  var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
  var reEscapeChar = /\\(\\)?/g;
  var result = [];
  value = !value ? '' : value + '';
  value.replace(rePropName, function(match, number, quote, string) {
    result.push(
      quote ? string.replace(reEscapeChar, '$1') : number || match
    );
  });
  return result;
};
function get(object, path) {
  path = toPath(path);
  var pathKey = path + '';

  if (!object) { return; }
  if (pathKey !== undefined && pathKey in object) {
    path = [pathKey];
  }
  var index = 0;
  var length = path.length;

  while (object && index < length) {
    object = object[path[index++]];
  }

  return index && index === length ? object : undefined;
};
function partial(path, options) {
  var locals;

  // parse options
  if (options) {
    // collection
    if (options.collection) {
      delete options.collection;
    } else if ('length' in options) {
      options = {};
    }

    // locals
    if (options.locals) {
      locals = options.locals;
      delete options.locals;
    }
  } else {
    options = {};
  }

  // merge locals into options
  if (locals) {
    options.__proto__ = locals;
  }

  // merge app locals into options
  for (var k in this) {
    if (this.hasOwnProperty(k)) {
      options[k] = options[k] || this[k];
    }
  }

  var translatePathRegex = /\//g;
  var objectPath = path.replace(translatePathRegex, '.');
  var arrayPath = toPath(objectPath);
  var template = get(window.Spark, arrayPath);

  // Try to load the template file
  if (template) {
    return template.RenderView(options);
  }

  template = get(window.Spark, ['Shared'].concat(arrayPath));

  // If that doesn't work, prefix "Shared" and try again
  if (template) {
    return template.RenderView(options);
  }

  var namespacePath = options.namespace.replace(translatePathRegex, '.');
  var namespaceArray = toPath(namespacePath);

  namespaceArray.shift(); // Remove Spark
  namespaceArray.pop();   // Remove template from path, to get folder

  template = get(window.Spark, namespaceArray.concat(arrayPath));

  // If we still don't have a template, chop up the path a bit
  if (template) {
    return template.RenderView(options);
  }

  // Still no template? Fail silently.
  return '<!-- ' + path + '-->';
};
function block(name, html) {
// bound to the blocks object in renderFile
  var blk = this[name];
  if (!blk) {
// always create, so if we request a
// non-existent block we'll get a new one
    blk = this[name] = new Block();
  }
  if (html) {
    blk.append(html);
  }
  return blk;
};
function layout(view){
  this.locals._layoutFile = view;
};
window.Spark = {"Shared":{"Redesign":{"Filters":{"_FilterViewOptions":{ 
  RenderView: function(locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace,
              partial: partial,
              tombstone: tombstone,
            });

            localsWithEjsMateMethods.partial = localsWithEjsMateMethods.partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var filterViewOptions = locals.filterViewOptions ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; if (filterViewOptions.Display.ShowMapTab) { ; buf.push('<div class="views" id="view_toggle"><div data-view="list" class="icon-as-button ', escape((1,  filterViewOptions.Display.CurrentView === 'list'  ? 'selected' : '' )), '"><svg class="sort-view-toggle-icon" aria-labelledby="a11y-view-list" viewBox="0 0 33 29" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M7.88020833.5 7.88020833 3.5 32.796875 3.5 32.796875.5 7.88020833.5ZM7.88020833 15.8984375 32.796875 15.8984375 32.796875 12.8984375 7.88020833 12.8984375 7.88020833 15.8984375ZM7.88020833 28.3203125 32.796875 28.3203125 32.796875 25.3203125 7.88020833 25.3203125 7.88020833 28.3203125ZM0 4 4 4 4 0 0 0 0 4ZM0 16.421875 4 16.421875 4 12.421875 0 12.421875 0 16.421875ZM0 28.84375 4 28.84375 4 24.84375 0 24.84375 0 28.84375Z" class="svg-list-icon"></path></svg><span id="a11y-view-list" class="pref-label">', escape((1,  Resources.Shared.Search.Tabs.List )), '</span></div><div data-view="map" class="icon-for-map icon-as-button ', escape((1,  filterViewOptions.Display.CurrentView === 'map'  ? 'selected' : '' )), '"><svg class="sort-view-toggle-icon" aria-labelledby="a11y-view-map" viewBox="0 1 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M13 3.5 7.4.9l0 0L.9 3.5v15.7l6.5-2.6 5.6 2.5 0 0 6-2.6.1 0V.8L13 3.5zM13.5 17.4V4.7L17.8 3v12.6L13.5 17.4zM12.1 4.4v13l-4.3-1.9v-13L12.1 4.4zM6.5 2.8v12.6L2.2 17V4.4L6.5 2.8z" id="Combined-Shape" class="svg-map-icon"></path></svg><span id="a11y-view-map" class="pref-label">', escape((1,  Resources.Shared.Search.Tabs.Map )), '</span></div></div> ');1; } ; buf.push('');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Filters._FilterViewOptions'}
,"_PopupMenuFilter":{ 
  RenderView: function(locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace,
              partial: partial,
              tombstone: tombstone,
            });

            localsWithEjsMateMethods.partial = localsWithEjsMateMethods.partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var request = locals.request ; buf.push(' ');1; var resources = locals.Resources || window.Resources ; buf.push(' ');1; var showDistance = locals.showDistance ; buf.push(' ');1; var sortingOptions = {
  Distance: resources.Shared.Redesign.Filters.Label_Sort_Distance,
  Popularity: resources.Shared.Redesign.Filters.Title_Featured,
  Name: resources.Shared.Redesign.Filters.Label_Sort_Name,
  Rating: resources.Shared.Redesign.Filters.Label_Sort_Rating,
  TimeDistance: resources.Shared.Redesign.Filters.Label_Sort_Distance,
  Newest: resources.Shared.Redesign.Filters.Label_Sort_Newest,
} ; buf.push(' ');8; var selectedDistance = request.SortString == 'Distance' ; buf.push(' ');8; var selectedPopularity = request.SortString == 'Popularity' ; buf.push(' ');8; var selectedName = request.SortString == 'Name' ; buf.push(' ');8; var selectedRating = request.SortString == 'Rating' ; buf.push(' ');8; var selectedNewest = request.SortString == 'Newest' ; buf.push('<div id="sort-dropdown__container"><div id="popup-menu-filter"> <button class="sort-dropdown__button" aria-label="sort by" aria-haspopup="true" data-toggle="dropdown" aria-expanded="false"> ', escape((8,  sortingOptions[request.SortString] || sortingOptions.Popularity )), '<span class="dropdown__icon arrow_down"></button><ul class="sort-dropdown__options" role="menu"> ');8; if (showDistance) { ; buf.push('<li role="presentation"> <button value="Distance" class="sort-dropdown__option_button ', escape((8,  selectedDistance ? 'highlight' : '' )), '" role="menuitem"> ', escape((8,  sortingOptions.TimeDistance )), '</button></li> ');8; } ; buf.push('<li role="presentation"> <button value="Popularity" class="sort-dropdown__option_button ', escape((8,  selectedPopularity ? 'highlight' : '' )), '" role="menuitem"> ', escape((8,  sortingOptions.Popularity )), '</button></li><li role="presentation"> <button value="Name" class="sort-dropdown__option_button ', escape((8,  selectedName ? 'highlight' : '' )), '" role="menuitem"> ', escape((8,  sortingOptions.Name )), '</button></li><li role="presentation"> <button value="Rating" class="sort-dropdown__option_button ', escape((8,  selectedRating ? 'highlight' : '' )), '" role="menuitem"> ', escape((8,  sortingOptions.Rating )), '</button></li><li role="presentation"> <button value="Newest" class="sort-dropdown__option_button ', escape((8,  selectedNewest ? 'highlight' : '' )), '" role="menuitem"> ', escape((8,  sortingOptions.Newest )), '</button></li></ul></div></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Filters._PopupMenuFilter'}
},"Modals":{"_OffersTooltip":{ 
  RenderView: function(locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace,
              partial: partial,
              tombstone: tombstone,
            });

            localsWithEjsMateMethods.partial = localsWithEjsMateMethods.partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var offersTooltip = locals.offersTooltip ; buf.push(' ');1; var Html = !!locals.Html ? locals.Html : window.Html ; buf.push(' ');1; var Model = locals.Model ; buf.push(' ');1; var PageType = locals.PageType ; buf.push(' ');1; var Request = locals.Request ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var System = locals.System ; buf.push(' ');1; var block = locals.block ; buf.push(' ');1; var layout = locals.layout ; buf.push(' ');1; var partial = locals.partial ; buf.push('<div class="menu dn menu-opened"><div class="menu-container"><div class="menu-main"><div class="menu-header"> ');1; if (offersTooltip.Offers.length > 1) { ; buf.push(' <strong>', escape((1,  (String.Format(Resources.Shared.Common.Modals.Offers_TooltipHeaderMultiple,offersTooltip.Offers.length)) )), '</strong> ');1; } ; buf.push(' ');1; if (offersTooltip.Offers.length == 1) { ; buf.push(' <strong>', escape((1,  (String.Format(Resources.Shared.Common.Modals.Offers_TooltipHeaderSingle)) )), '</strong> ');1; } ; buf.push('</div><div class="modal-list tooltip-offers"> ');1; offersTooltip.Offers.forEach(function(offer) { ; buf.push(' <label class="offer menu-list-label">', escape((1,  (offer) )), '</label> ');1; }) ; buf.push('</div></div><div class="dn-arrow"></div></div></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Modals._OffersTooltip'}
},"Results":{"_ResultsTitle":{ 
  RenderView: function(locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace,
              partial: partial,
              tombstone: tombstone,
            });

            localsWithEjsMateMethods.partial = localsWithEjsMateMethods.partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var resultsTitle = locals.resultsTitle;
var Resources = !!locals.Resources ? locals.Resources : window.Resources;
var partial = locals.partial;
var hasAddonRestaurants = locals.helpers.hasAddonRestaurants(resultsTitle);
var showSearchSummary = resultsTitle.Request.OriginalTerm && resultsTitle.Display.Metro.Name;
var originalQuery = resultsTitle.Request.OriginalTerm;
; buf.push('<div class="flex-row-justify results-header"> ');7; if (showSearchSummary) { ; buf.push('<div class="results-title-summary-container"><h2 class="results-title-summary"> ', escape((7,  String.Format(Resources.Shared.Redesign.Results.Title_Search_Summary, '"' + originalQuery + '"', resultsTitle.Display.Metro.Name) )), '</h2></div> ');7; } ; buf.push(' ');7; if (hasAddonRestaurants) { ; buf.push('<h3 class="results-title single-search-result"> ', (7,  Resources.Shared.Redesign.Results.RestaurantsYouMayLike ), '</h3> ');7; } else { ; buf.push(' ');7; if (!String.IsNullOrEmpty(resultsTitle.Request.Title)) { ; buf.push('<h2 class="page-title">', escape((7,  resultsTitle.Request.Title )), '</h2> ');7; } ; buf.push('<h3 id="results-title" class="results-title color-dark"> ');7; if (resultsTitle.IsPromo) { ; buf.push(' ');7; if (resultsTitle.Results.Restaurants.length == 1) { ; buf.push(' ');7; var searchTitle=Resources.Shared.Redesign.Results.Title_Promos ; buf.push(' ', escape((7,  String.Format(searchTitle, 1) )), ' <span class="result-promo-title">', escape((7,  resultsTitle.Display.ResultsTitle )), '</span> ');7;} else {; buf.push(' ');7; var searchTitle=Resources.Shared.Redesign.Results.Title_Promos_Plural ; buf.push(' ', escape((7,  String.Format(searchTitle, resultsTitle.Results.Total) )), ' <span class="result-promo-title">', escape((7,  resultsTitle.Display.ResultsTitle )), '</span> ');7; } ; buf.push(' ');7;} else {; buf.push(' ', escape((7,  resultsTitle.Display.ResultsTitle )), ' ');7; } ; buf.push('</h3> ');7; } ; buf.push(' ');7; if (!hasAddonRestaurants || resultsTitle.Display.CurrentView === 'map') { ; buf.push('<div class="sort-view-filters"><div id="sort-filters" class="filter-option right filter-option-sort-orders"> ', (7,  partial('Redesign/Filters/_PopupMenuFilter', { request: resultsTitle.Request })), '</div><div class="search-tab right view-toggle" role="button" tabindex="0"> ', (7,  partial('Redesign/Filters/_FilterViewOptions', {
          filterViewOptions: resultsTitle
        }) ), '</div></div> ');9; } ; buf.push('</div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._ResultsTitle'}
,"_ConsumerDisclosure":{ 
  RenderView: function(locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace,
              partial: partial,
              tombstone: tombstone,
            });

            localsWithEjsMateMethods.partial = localsWithEjsMateMethods.partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var Resources = locals.Resources || window.Resources ; buf.push(' ');1; var Request = locals.Request || {} ; buf.push(' ');1; if (locals.SortBy === 'Popularity' && Request.PageType !== 1) { ; buf.push('<div class="content-section-consumer-disclosure"><div class="consumer-disclosure-border"></div> <span class="consumer-disclosure-text">', (1,  Resources.Shared.Redesign.Results.Title_Consumer_Disclosure ), '</span><div class="consumer-disclosure-container"><div id="consumer-disclosure-icon" role="button" aria-label="', (1,  Resources.Shared.Redesign.Results.Tooltip_Label_Consumer_Disclosure ), '" tabindex="0" aria-describedby="consumer-disclosure-tooltip"> ');1; /* img tag has an empty alt tag on purpose because we have an aria-label above */ ; buf.push(' <img src="//media.otstatic.com/search-result-node/images/compressed/ic_question.svg" alt=""></div><div id="consumer-disclosure-tooltip"> ', (1,  Resources.Shared.Redesign.Results.Popover_Consumer_Disclosure ), '</div></div></div> ');1; } ; buf.push('');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._ConsumerDisclosure'}
,"_TimeslotAvailability":{ 
  RenderView: function(locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace,
              partial: partial,
              tombstone: tombstone,
            });

            localsWithEjsMateMethods.partial = localsWithEjsMateMethods.partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var timeslotsLeft = locals.timeslotsLeft ; buf.push(' ');1; var experiments = locals.experiments ; buf.push(' ');1; var Resources = locals.Resources || window.Resources ; buf.push(' ');1; if (timeslotsLeft < 5 && timeslotsLeft) { ; buf.push(' ');1; var timeslotString = timeslotsLeft ; buf.push(' ');1; var timeslot = Resources.Shared.Redesign.Strings.TimeslotAvailability_Single ; buf.push(' ');1; var timeslots = String.Format(Resources.Shared.Redesign.Strings.TimeslotAvailability_Multiple, timeslotString) ; buf.push(' ');1; var message = timeslotsLeft === 1 ? timeslot : timeslots ; buf.push(' ');1; var timeslot2 = Resources.Shared.Redesign.Strings.TimeslotAvailability_Single_2 ; buf.push(' ');1; var timeslots2 = String.Format(Resources.Shared.Redesign.Strings.TimeslotAvailability_Multiple_2, timeslotString) ; buf.push(' ');1; var message2 = timeslotsLeft === 1 ? timeslot2 : timeslots2 ; buf.push(' ');1; if (experiments.sfx1267 == 1 ) { ; buf.push('<div class="notice-timeslot"><span class="clock-icon"></span> <span>', (1,  message2 ), '</span></div> ');1; } else { ; buf.push('<div class="notice-timeslot"><span class="clock-icon"></span> <span>', (1,  message ), '</span></div> ');1; } ; buf.push(' ');1; } ; buf.push('');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._TimeslotAvailability'}
,"_Explanation":{ 
  RenderView: function(locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace,
              partial: partial,
              tombstone: tombstone,
            });

            localsWithEjsMateMethods.partial = localsWithEjsMateMethods.partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var resultViewModel = locals.resultViewModel ; buf.push(' ');1; var restaurant = locals.restaurant ; buf.push(' ');1; if (resultViewModel.Display.showExplanations && restaurant.Explanation) { ; buf.push('<div class="restaurant-explanation"><span class="otkit--thumbs-up-icon--red"></span> ', escape((1,  restaurant.Explanation )), '</div> ');1; } ; buf.push('');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._Explanation'}
,"_RestaurantPromo":{ 
  RenderView: function(locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace,
              partial: partial,
              tombstone: tombstone,
            });

            localsWithEjsMateMethods.partial = localsWithEjsMateMethods.partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var searchViewModelPromo = locals.searchViewModelPromo ; buf.push(' ');1; var restaurantPromo = locals.restaurantPromo ; buf.push(' ');1; var restaurantViewModelPromo = locals.restaurantViewModelPromo ; buf.push(' ');1; var Resources = locals.Resources || window.Resources ; buf.push('<div class="rest-row-promo-wrapper"> ');1; if (!String.IsNullOrEmpty(restaurantPromo.Message)) { ; buf.push(' ');1; if (locals.Model.Promo.IsRestaurantWeek) { ; buf.push('<p>', escape((1,  Resources.Shared.Redesign.Strings.Label_TopOffer )), '</p> ');1; } ; buf.push('<div class="rest-promo-message"> ', (1,  (restaurantPromo.Message) ), '</div> ');1; } ; buf.push('</div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._RestaurantPromo'}
,"_SingleSearchReserveLink":{ 
  RenderView: function(locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace,
              partial: partial,
              tombstone: tombstone,
            });

            localsWithEjsMateMethods.partial = localsWithEjsMateMethods.partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var searchViewModel = locals.searchViewModel ; buf.push(' ');1; var restaurantViewModel = locals.restaurantViewModel ; buf.push(' ');1; var partial = locals.partial ; buf.push(' ');1; var Resources = locals.Resources || window.Resources ; buf.push(' ');1; if (searchViewModel  &&
    searchViewModel.IsPromo &&
    restaurantViewModel &&
    restaurantViewModel.Promo) { ; buf.push(' ', (4,  partial('Redesign/Results/_RestaurantPromo', {
    searchViewModelPromo: searchViewModel.Promo,
    restaurantPromo: restaurantViewModel.Promo,
    restaurantViewModelPromo: restaurantViewModel
  }) ), ' ');8;} else if (!searchViewModel.Request.IsAvailabilityRequest) { ; buf.push('<div class="rest-row-reserve-button"> <a class="reserve-link button medium" data-profile-url="', escape((8,  (restaurantViewModel.ProfileUri) )), '">', escape((8,  (Resources.Shared.Redesign.Strings.Reserve_Now) )), '</a></div> ');8; } ; buf.push('');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._SingleSearchReserveLink'}
,"_Timeslots":{ 
  RenderView: function(locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace,
              partial: partial,
              tombstone: tombstone,
            });

            localsWithEjsMateMethods.partial = localsWithEjsMateMethods.partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var timeslots = locals.timeslots ; buf.push(' ');1; var restaurantName = locals.restaurant.Name ; buf.push(' ');1; var timeSlotsRequest = locals.timeSlotsRequest ; buf.push(' ');1; var displayOnlyPopTimes = locals.displayOnlyPopTimes ; buf.push(' ');1; var Model = locals.Model ; buf.push(' ');1; var experiments = Model.Experiments.enums ; buf.push(' ');1; var OnlyExactDateTime = Model.Request.OnlyExactDateTime ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var showPopTimes = locals.showPopTimes ; buf.push(' ');1; var partial = locals.partial ; buf.push(' ');1; var isPopTableResult = locals.isPopTableResult ; buf.push(' ');1; var timeslotsLeft = timeslots.TimeSlots.filter(function(el) {
  return el.IsAvail;}).length; ; buf.push(' ');2; var isMobile = Model.UserAgent.indexOf(/(tablet|touch|Android|Pixel|iPad|iPhone)/g) !== -1 ; buf.push(' ');2; var giftParams = Model.giftParams ; buf.push(' ');2; var timeslotsTableCategories = [] ; buf.push(' ');2; var correlationId = locals.correlationId ; buf.push(' ');2; if (!isPopTableResult) { ; buf.push('<div class="message-alerts"> ');2; if (!OnlyExactDateTime && timeslots.TimeSlotsComplete) { ; buf.push(' ', (2,  partial('Redesign/Results/_TimeslotAvailability', {
        timeslotsLeft: timeslotsLeft,
        Resources: Resources,
        partial: partial,
        experiments: Model.Experiments
      }) ), ' ');7; } ; buf.push(' ', (7,  partial('Redesign/Results/_Explanation', {}) ), '</div> ');7; } ; buf.push(' ');7; if (isMobile) {
  timeslots.TimeSlots = timeslots.TimeSlots.slice(0, 5);
}
; buf.push(' ');10; if (timeslots.HasAvail) { ; buf.push(' ');10;
    var showBonusPointsLegend = false;
    var restaurantHasOffers = false;
    var restRowTimesContainerClass = ['rest-row-times-cont'];

    timeslots.TimeSlots.forEach(function (timeSlot) {
      if (timeSlot.IsAvail && timeSlot.OfferIds && timeSlot.OfferIds.length > 0) {
        restaurantHasOffers = true;
      }
    });

    if (restaurantHasOffers) {
      restRowTimesContainerClass.push('has-offers');
    }
  ; buf.push('<div class="', escape((24,  restRowTimesContainerClass.join(' ') )), '"><div class="rest-row-times"><div class="timeslot-window"><ul class="availability-row-container"> ');24; timeslots.TimeSlots.forEach(function(timeSlot, timeSlotIndex) { ; buf.push(' ');24;
              var timeslotDisabled = !timeSlot.IsAvail || (displayOnlyPopTimes && !timeSlot.HasPop);
              var isExact = timeSlotIndex == 2;
              var hash = timeSlot.Hash || '';
              var hasPop = timeSlot.HasPop && showPopTimes;
              var hasOffers = timeSlot.HasOffers;
              var offerIds = hasOffers ? String.Join(',', timeSlot.OfferIds) : '';
              var offersCount = timeSlot.OfferIds.length + (hasPop ? 1 : 0);
              var isPremium = (timeSlot.Price && timeSlot.Price.Amount > 0);
              var isTicketing = timeSlot.TicketExperiences && timeSlot.TicketExperiences.length;
              var hash = timeSlot.Hash;

              var hasTableCategories = timeSlot.TableCategories
                && timeSlot.TableCategories.length
                && !(timeSlot.TableCategories.indexOf("default") !== -1
                  && timeSlot.TableCategories.length === 1);

              if (hasTableCategories && timeSlot.TimeString.indexOf('*') === -1 && Model.Experiments.sfx523 !== 2) {
                timeSlot.TimeString += '*';
              }

              var domainCulture = locals.Model.DomainCulture;
              var cultureUrlSegment = domainCulture.addCultureToPath ?  '/' + domainCulture.Culture : '';
              var pointValue = timeSlot.Points || (hasPop ? 1000 : 100);
              var slotTime = timeSlot.DateTime;

              if (typeof moment != "undefined") {
                slotTime = moment(timeSlot.LinkString).format('HH:mm:ss');
              } else {
                if (typeof slotTime === 'string') {
                  slotTime = timeSlot.DateTime.substring(timeSlot.DateTime.indexOf('T')+1);
                }
              }

              var restRefParam = Model.Request.RestRef ? '&restref=' + timeslots.Id : '';
              var refParam = Model.Request.Ref ? '&ref=' + Model.Request.Ref : '';
              var timeslotFormat = '{6}/book/validate?rid={0}&d={2}&p={1}&pt={5}&ss=0&sd={2}&pofids={3}&hash={4}&corrid={7}&ref={8}';

              if (pointValue > 100) {
                timeslotFormat += '&i=1';
              }

              if (isTicketing) {
                timeslotFormat += '&st=Ticketed&tik=' + encodeURIComponent(timeSlot.tik);
              }

              if(timeSlot.SlotAvailabilityToken) {
                timeslotFormat += '&avt=' + timeSlot.SlotAvailabilityToken;
              }

              var slotUrl = String.Format(
                timeslotFormat,
                timeslots.Id,
                timeSlotsRequest.Covers,
                timeSlot.LinkString,
                String.Join(",", timeSlot.OfferIds),
                hash,
                pointValue,
                cultureUrlSegment,
                correlationId,
                refParam
              );

              var timeslotClasses = ['rest-row-times-btn'];

              if (isExact) {
                timeslotClasses.push('exact');
              }

              if (timeslotDisabled || (isPremium && !Model.Display.ShowPremiumAccess)) {
                timeslotClasses.push('unavailable');
              } else {
                timeslotClasses.push('timeslot');
                if (isPremium && Model.Display.ShowPremiumAccess) {
                  timeslotClasses.push('dtp-button-premium');
                }
                if (hasOffers) {
                  timeslotClasses.push('has-offers');
                }
                if (isTicketing) {
                  timeslotClasses.push('is-ticketing');
                }
              }

              var timeslotParentClasses = ['timeslot-option'];

              if (timeSlot.IsAvail) {
                timeslotParentClasses.push('timeslot-control');
              }

              if ((isPremium && Model.Display.ShowPremiumAccess) || hasPop || hasOffers) {
                timeslotParentClasses.push('offer-container');

                if (isPremium && Model.Display.ShowPremiumAccess) {
                  timeslotParentClasses.push('dtp-button-premium-wrapper');
                }
              }

              var giftAmount;
              if (timeSlot.LoyaltyRedemption && giftParams) {
                var restaurantRewards = Model.Results.PointRedemptionRewards[timeslots.CountryCode];
                if (restaurantRewards) {
                  var timeSlotTier = restaurantRewards[timeSlot.LoyaltyRedemption];
                  if (timeSlotTier) {
                    giftAmount = timeSlotTier.Levels[giftParams.giftAmount]
                  }
                }
              }

              var instantEligible = timeSlot.instantEligible;
              var instantUrl = timeSlot.instantUrl;
             ; buf.push('<li class="', escape((135,  timeslotParentClasses.join(' ') )), '"> <a class="', escape((135,  timeslotClasses.join(' ') )), '" ');135; if (timeSlot.LinkString) { ; buf.push(' data-rid="', escape((135,  timeslots.Id )), '" data-name="', escape((135,  timeslots.Name )), '" data-datetime="', escape((135,  timeSlot.LinkString )), '" data-covers="', escape((135,  timeSlotsRequest.Covers )), '" ');135; } ; buf.push(' ');135; if (giftAmount ||
                       hasOffers ||
                       !Model.Request.RestRef &&
                         ((hasPop && displayOnlyPopTimes && !timeslots.HasOffers) ||
                           (hasPop && offersCount === 1)) ||
                       isPremium && Model.Display.ShowPremiumAccess) { ; buf.push(' aria-describedby="bonus_pt_', escape((140,  hash )), '" ');140; } ; buf.push(' ');140; if (timeslotDisabled || (isPremium && !Model.Display.ShowPremiumAccess)) { ; buf.push(' data-offers="', escape((140,  offerIds )), '">&nbsp; ');140; } else { ; buf.push(' ');140; if (hasTableCategories) { ; buf.push(' href="#!" aria-describedby="table-categories-tooltip-id" data-href="', escape((140,  slotUrl )), '" data-table-categories="', (140,  timeSlot.TableCategories ), '" data-table-categories-tooltip-title="Table Types" ');140; } else if (isTicketing) { ; buf.push(' href="#!" onclick="OT.Common.OCModals.show({ componentName: \'ticketing-modal-web\', componentVersion: \'<3.0.0\', props: { tid: ', (140,  timeSlot.TicketExperiences[0].Id ), ', dateTime: ', escape((140,  JSON.stringify(timeSlot.DateTime) )), ', covers: ', (140,  timeSlotsRequest.Covers ), ', url: ', escape((140,  JSON.stringify(slotUrl) )), ' } })" ');140; } else { ; buf.push(' href="', escape((140,  slotUrl )), '" onclick="OT.BestAnalytics.logRestaurantVisit(', escape((140, timeslots.Id)), ', \'', escape((140, timeSlot.LinkString.substr(timeSlot.LinkString.indexOf(' ')+1))), '\')" ');140; } ; buf.push(' ');140; if (hasPop || hasOffers) { ; buf.push(' ');140; var points = String.Format(Resources.Shared.Redesign.Strings.PointsText, pointValue) ; buf.push(' ');140; var offer = Resources.Shared.Redesign.Strings ; buf.push(' ');140; var offerPlural = offersCount > 1 ? offer.TimeslotLegend_Offers : offer.TimeslotLegend_Offer ; buf.push(' data-has-pop="', escape((140,  hasPop )), '" data-offers="', escape((140,  offerIds )), '" ');140; } else if (isPremium && Model.Display.ShowPremiumAccess) { ; buf.push(' data-premium-access-price-amount="', escape((140,  timeSlot.Price.Amount )), '"> ');140; } ; buf.push(' ');140; if (instantEligible && instantUrl) { ; buf.push(' data-instant-eligible="true" data-instant-url="', escape((140,  instantUrl )), '" ');140; } ; buf.push('> ');140; if (isTicketing && !hasTableCategories) { ; buf.push('<span class="ticket-icon"></span> ');140; } ; buf.push(' <span>', escape((140,  timeSlot.TimeString )), '</span> <span class="off-screen">', escape((140,  String.Format(Resources.Shared.Redesign.Strings.TimeslotAccessibleDescription, restaurantName) )), '</span> ');140; if (isTicketing || hasTableCategories) { ; buf.push(' <span class="off-screen">', escape((140,  Resources.Shared.Redesign.Strings.TimeslotAccessibleModalWarning )), '</span> ');140; } ; buf.push(' ');140; } ; buf.push('</a> ');140; if (hasTableCategories) { ; buf.push('<div class="js-table-categories-tooltip table-categories-tooltip" id="table-categories-tooltip-id"><div class="table-categories-tooltip-arrow"></div><div class="table-categories-tooltip-container"><h5 class="upcase-style">', escape((140,  Resources.Shared.Search.TableCategories.TooltipTitle )), '</h5> ');140; timeSlot.TableCategories.forEach(function(category) { ; buf.push(' ');140; tableCategoryName = Resources.Shared.Search.TableCategories.Categories[category.toLowerCase()] ; buf.push(' ');140; if (timeslotsTableCategories.indexOf(tableCategoryName) === -1) { ; buf.push(' ');140; timeslotsTableCategories.push(tableCategoryName) ; buf.push(' ');140; } ; buf.push('<div class="table-categories-tooltip-category">', escape((140,  tableCategoryName )), '</div> ');140; }) ; buf.push('</div></div> ');140; } ; buf.push(' ');140; if (giftAmount) { ; buf.push('<div id="bonus_pt_', escape((140,  hash )), '" class="with-points timeslot-with-redemption"> ', escape((140,  giftAmount.Name )), '</div> ');140; } else if (hasOffers) { ; buf.push('<div id="bonus_pt_', escape((140,  hash )), '" class="with-points"><i class="with-offers">', escape((140,  offersCount )), '</i>', escape((140,  " " + offerPlural )), '</div> ');140; } else if (!Model.Request.RestRef &&
                ((hasPop && displayOnlyPopTimes && !timeslots.HasOffers) ||
                (hasPop && offersCount === 1))) { ; buf.push('<div id="bonus_pt_', escape((142,  hash )), '" class="with-points" data-points-text=\'', escape((142,  points )), '\'> ', escape((142,  points )), '</div> ');142; } else if (isPremium && Model.Display.ShowPremiumAccess) { ; buf.push('<div id="bonus_pt_', escape((142,  hash )), '" class="with-points dtp-button-premium-label">Premium</div> ');142; } ; buf.push('</li> ');142; }) ; buf.push(' ');142; if(!timeslots.TimeSlotsComplete) { ; buf.push('<li class="timeslot-option timeslot-empty"></li><li class="timeslot-option timeslot-empty"></li> ');142; } ; buf.push('</ul></div></div></div> ');142;} else {; buf.push('<div class="rest-row-times-cont"> ');142; if (timeslots.BlockedDayMsg) { ; buf.push('<p class="not-available-message"> ', (142,  timeslots.BlockedDayMsg ), '</p> ');142; } else { ; buf.push(' <a href="', escape((142,  timeslots.ProfileUri )), '" class="button minimal">', escape((142,  Resources.Shared.Common.Results.NextAvailableButton )), '</a> ');142; if (!String.IsNullOrEmpty(timeslots.UnAvailMsg)) { ; buf.push('<p class="not-available-message"> ', (142,  timeslots.UnAvailMsg ), '</p> ');142; } ; buf.push(' ');142; } ; buf.push('</div> ');142; } ; buf.push(' ');142; if (Model.Experiments.sfx523 && !isPopTableResult && timeslotsTableCategories.length) { ; buf.push('<div id="rest-row-table-categories" class="rest-row-meta"> ', escape((142,  Resources.Shared.Search.TableCategories.DescriptionTitle + ": " )), ' ');142; timeslotsTableCategories.forEach(function(tableCategory, index) { ; buf.push(' ');142; if (index < timeslotsTableCategories.length - 1) { ; buf.push(' ', escape((142,  tableCategory )), ', ');142; } else { ; buf.push(' ', escape((142,  tableCategory )), ' ');142; } ; buf.push(' ');142; }) ; buf.push('</div> ');142; } ; buf.push(' ', (142,  partial('Redesign/Results/_SingleSearchReserveLink', {
  searchViewModel: Model,
  restaurantViewModel: timeslots
}) ), '');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._Timeslots'}
,"_ShortlistButton":{ 
  RenderView: function(locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace,
              partial: partial,
              tombstone: tombstone,
            });

            localsWithEjsMateMethods.partial = localsWithEjsMateMethods.partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var isInShortlist = locals.isInShortlist ; buf.push(' ');1; var isDisabled = locals.isDisabled ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var shortlistButtonClasses = ["shortlist-button"];

if (isInShortlist) {
    shortlistButtonClasses.push("shortlist-button-isInShortlist");
}

if (isDisabled) {
    shortlistButtonClasses.push("shortlist-button-isDisabled");
}
; buf.push('<div class="', escape((10,  shortlistButtonClasses.join(' ') )), '" data-restaurant-id="', escape((10,  locals.restaurantId )), '" data-restaurant-title="', escape((10,  locals.restaurantTitle )), '" data-restaurant-uri="', escape((10,  locals.restaurantUri )), '" data-reviews="', escape((10,  locals.reviews )), '" data-profile-uri="', escape((10,  locals.profileUri )), '"> <button aria-disabled="', escape((10,  isDisabled )), '" aria-pressed="', escape((10,  isInShortlist )), '"><span>', escape((10,  Resources.Shared.Common.Results.AddToShortlist )), '</span></button></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._ShortlistButton'}
,"_Reviews":{ 
  RenderView: function(locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace,
              partial: partial,
              tombstone: tombstone,
            });

            localsWithEjsMateMethods.partial = localsWithEjsMateMethods.partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var reviews = locals.reviews ; buf.push(' ');1; var url = locals.url ; buf.push(' ');1; var experiments = locals.Experiments ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var resultViewModel = locals.resultViewModel ; buf.push(' ');1; var resourceResults = Resources.Shared.Redesign.Results ; buf.push(' ');1; var total = reviews.Total ; buf.push(' ');1; var reviewText = String.Format(reviews.Total === 1 ? resourceResults.Reviews : resourceResults.Reviews_Plural, total) ; buf.push(' ');1; var showRatings = reviews && reviews.Total > 0 && reviews.ShowReviews ; buf.push(' ');1; var isPopTableResult = locals.isPopTableResult ; buf.push('<div class="rest-row-review"> ');1; if (showRatings) { ; buf.push(' ');1; var reviewRating = reviews.Rating ; buf.push(' ');1; var reviewCalculatedRating = reviews.CalculatedRating ; buf.push(' ');1; var starTitle = String.Format(reviewRating == 1 ? Resources.Strings.StarRatingText : Resources.Strings.StarRatingText_Plural, reviewRating) ; buf.push(' ');1; var totalStarsFill = (reviewRating *20) -1; buf.push('<div class="star-rating review-container xsmall-medium"> ');1; if(reviews.CalculatedRatingTerm) { ; buf.push(' ');1; if(experiments.sfx1149) { ; buf.push('<div role="img" class="star-rating-score" aria-label="', escape((1,  starTitle )), '"> ');1; for(var ratingStep = 1; ratingStep <= 5; ratingStep++) { ; buf.push(' ');1; var rounding = Math.round((reviewRating - ratingStep + 1) * 4) / 4 ; buf.push(' ');1;
                var starAmount;
                if (rounding >= 1) {
                  starAmount = "full";
                } else if (rounding === 0.75) {
                  starAmount = "threequarter";
                } else if (rounding === 0.5) {
                  starAmount = "half";
                } else if (rounding === 0.25) {
                  starAmount = "quarter";
                } else {
                  starAmount = "empty";
                }
              ; buf.push(' <span class="star" aria-hidden="true"><img src="/s/static/images/compressed/star-', escape((14,  starAmount )), '.svg"/></span> ');14; } ; buf.push('</div> ');14; } else { ; buf.push('<div class="star-rating"><div class="star-wrapper small"><div class="all-stars"></div><div class="all-stars filled" style="width: ', escape((14,  totalStarsFill )), '%"></div></div></div> ');14; } ; buf.push('<div class="review-rating-text xsmall-bold"> <span>', escape((14,  resourceResults[reviews.CalculatedRatingTerm] )), '</span></div> ');14; } ; buf.push(' <a class="review-link" href="', (14,  url ), '" target="_blank"><span class="underline-hover">(', escape((14,  total )), ')</span> <span class="screen-reader">', escape((14,  Resources.Shared.Redesign.Results.Review )), ' - ', escape((14,  locals.restaurant.Name )), '</span></a></div> ');14; } else { ; buf.push('<div class="review-container"> ', escape((14,  Resources.Shared.Redesign.Results.ReviewsComingSoon )), '</div> ');14; } ; buf.push('</div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._Reviews'}
,"_Pricing":{ 
  RenderView: function(locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace,
              partial: partial,
              tombstone: tombstone,
            });

            localsWithEjsMateMethods.partial = localsWithEjsMateMethods.partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var price = locals.price ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var experiments = locals.experiments ; buf.push('<div class="rest-row-pricing"> <i class="pricing--the-price">');1; [1,2,3,4].forEach(function(i, iIndex) { ; buf.push(' ');1; if (i <= price) { ; buf.push(' ', escape((1,  Resources.Shared.Redesign.Strings.CurrencySymbol )), ' ');1; } ; buf.push(' ');1; }) ; buf.push('</i> <span class="pricing--not-the-price">');1; [1,2,3,4].forEach(function(i, iIndex) { ; buf.push(' ');1; if (i <= 4 - price) { ; buf.push(' ', escape((1,  Resources.Shared.Redesign.Strings.CurrencySymbol )), ' ');1; } ; buf.push(' ');1; }) ; buf.push('</span></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._Pricing'}
,"_FreeTextBlurb":{ 
  RenderView: function(locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace,
              partial: partial,
              tombstone: tombstone,
            });

            localsWithEjsMateMethods.partial = localsWithEjsMateMethods.partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1;
  var lookup = locals.lookup;
  var freeTextBaseCheck = locals.freeTextBaseCheck;
  var restaurant = locals.restaurant;

  var freeTextBlurb = '';
  if (freeTextBaseCheck) {
    var single = {};
    single[lookup[restaurant.FreeText.SingleRelevanceSource]] = [restaurant.FreeText.SingleRelevance];
    var type = Object.keys(single)[0];
    var freeTextMatch = single[type].toString();
    var addEllipsis = '&hellip;'
    if (type !== 'Menu') {
      // Converts a randomly chopped sentence into one ending in ...
      freeTextMatch = freeTextMatch.trim().replace(/^([.,'’\/!?$%\^&\*;:}=\-_`~ )]*)/gm, '').trim();
      if (freeTextMatch[0] !== freeTextMatch[0].toUpperCase()) {
        freeTextMatch = '&hellip;' + freeTextMatch;
      }
      if (type === 'Description' || !('.!?'.indexOf(freeTextMatch.slice(-1)) !== -1)) {
        freeTextMatch += '&hellip;';
      }
    }
  }
; buf.push('<div class="freetext"><span class="freetext-item"><span class="freetext-icon freetext-', escape((24,  type.toLowerCase() )), '-icon"></span> <span class="freetext-match freetext-match-', escape((24,  type.toLowerCase() )), '"><span class="match">', (24,  freeTextMatch ), '</span></span></span></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._FreeTextBlurb'}
,"_TicketingDetails":{ 
  RenderView: function(locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace,
              partial: partial,
              tombstone: tombstone,
            });

            localsWithEjsMateMethods.partial = localsWithEjsMateMethods.partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; 
var restaurant = locals.restaurant;
var resultViewModel = locals.resultViewModel;
var Resources = locals.Resources;

if(restaurant.HasTicketedExperienceDetails) {
  var hasMultipleExperiences = resultViewModel.Results.TicketedExperiences[restaurant.Id.toString()].length > 1;
  var ticketingDetails = resultViewModel.Results.TicketedExperiences[restaurant.Id.toString()][0];
; buf.push('<div class="rest-row-ticketing-details"> ');9; if(hasMultipleExperiences) { ; buf.push('<h2 class="rest-row-ticketing-details__heading">', escape((9,  Resources.Shared.Common.Results.Ticketing_Multi_Title )), '</h2><p class="rest-row-ticketing-details__description">', escape((9,  Resources.Shared.Common.Results.Ticketing_Multi_Message )), '</p> ');9; } else {
  var pricePerCoverFormatted = ticketingDetails.ticketTypes[0].pricePerCoverFormatted;
; buf.push('<h2 class="rest-row-ticketing-details__heading">', escape((11,  ticketingDetails.title )), '</h2><p class="rest-row-ticketing-details__description">', escape((11,  String.Format(Resources.Shared.Common.Results.Ticketing_Message, pricePerCoverFormatted) )), '</p> <button class="rest-row-ticketing-details__action" onclick="OT.Common.OCModals.show({\n    componentName: \'ticketing-modal-web\',\n    componentVersion: \'<3.0.0\',\n    props: {\n      tid: ', (15,  ticketingDetails.experienceId ), '\n    }\n  })">', escape((17,  Resources.Shared.Common.Results.Ticketing_DetailsAction )), '</button> ');17; } ; buf.push('</div> ');17; } ; buf.push('');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._TicketingDetails'}
,"_Result":{ 
  RenderView: function(locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace,
              partial: partial,
              tombstone: tombstone,
            });

            localsWithEjsMateMethods.partial = localsWithEjsMateMethods.partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var restaurant = locals.restaurant ; buf.push(' ');1; var reviews = locals.restaurant.Reviews ; buf.push(' ');1; var experiments = locals.Experiments || {} ; buf.push(' ');1; var resultViewModel = locals.resultViewModel ; buf.push(' ');1; var onlyPopTimes = locals.onlyPopTimes ; buf.push(' ');1; var showImages = locals.showImages ; buf.push(' ');1; var Request = locals.Request || resultViewModel.Request ; buf.push(' ');1; var partial = locals.partial ; buf.push(' ');1; var restaurantIndex = locals.restaurantIndex ; buf.push(' ');1; var showPop = locals.showPop ; buf.push(' ');1;/* If the results are showing in the yellow box at the top, this is a PopTableResult. */; buf.push(' ');1; var isPopTableResult = locals.isPopTableResult ; buf.push(' ');1; var Resources = locals.Resources || window.Resources ; buf.push(' ');1; var milesToDisplay = locals.helpers.milesToDisplay ; buf.push(' ');1; var listIndex = restaurantIndex + 1 ; buf.push(' ');1; var missingRestImage = "/s/static/images/no-image.png" ; buf.push(' ');1; var dinersChoiceBaseCheck = restaurant.Reviews.Awards && restaurant.Reviews.Awards.length && !isPopTableResult && resultViewModel.Request.PageType === 0 ; buf.push(' ');1; var freeTextBaseCheck = !isPopTableResult && Request && restaurant.FreeText ; buf.push(' ');1; var contextType =  Resources.Shared.Search.FreeTextSearch ; buf.push(' ');1; var NEWLY_ADDED_RESTAURANTS_PAGE = resultViewModel.Request.PageType === 5 ; buf.push(' ');1; var isPromoted = restaurant.IsPromoted && !isPopTableResult ; buf.push(' ');1; var showDistance = locals.showDistance ; buf.push(' ');1; var isMarketed = !locals.ignoreMarketing ; buf.push(' ');1; var showAffiliatedRestaurantsLink = locals.showAffiliatedRestaurantsLink ; buf.push(' ');1; var correlationId = locals.correlationId ; buf.push(' ');1; var campaignIds = locals.Results && locals.Results.CampaignIds ? locals.Results.CampaignIds[restaurant.Id] : undefined ; buf.push(' ');1; var lookup = {
  menu: 'Menu',
  description: 'Description',
  reviews: 'Reviews'
};; buf.push(' ');5; var cuisine = restaurant.Cuisine; ; buf.push(' ');5; var profileUri = restaurant.PageLink && restaurant.PageLink.link ; buf.push(' ');5; var restaurantAvailabilityToken = restaurant.RestaurantAvailabilityToken || '' ; buf.push(' ');5; var bodyCssClasses = ["result", "content-section-list-row", "cf"];

  if (resultViewModel.Display.ShowTimeSlotsInResults) {
    bodyCssClasses.push("with-times");
  }
; buf.push(' ');10; var timeslots = resultViewModel.Display.ShowTimeSlotsInResults ? partial('Redesign/Results/_Timeslots', {
  timeslots: restaurant,
  timeSlotsRequest: resultViewModel.Request,
  notAvailableButtonClass: '',
  displayOnlyPopTimes: onlyPopTimes,
  showPopTimes: showPop,
  Model: resultViewModel,
  partial: partial,
  isPopTableResult: isPopTableResult,
  correlationId: correlationId
}) : '' ; buf.push(' ');20; var photo = (restaurant.Photos && restaurant.Photos.length > 0) ? restaurant.Photos[0].url : missingRestImage ; buf.push('<li class="', escape((20,  bodyCssClasses.join(' ') )), '" data-id="', escape((20,  restaurantIndex )), '" data-rid="', escape((20,  restaurant.Id )), '" data-is-promoted="', escape((20,  isPromoted )), '" data-is-marketed="', escape((20,  isMarketed )), '" data-offers="', escape((20,  String.Join(',', restaurant.OfferIds) )), '" data-lat="', escape((20,  restaurant.Lat )), '" data-lon="', escape((20,  restaurant.Lon )), '" data-index="', escape((20,  listIndex )), '" data-restaurant-availability-token="', escape((20,  restaurantAvailabilityToken )), '" ', (20,  campaignIds ? 'data-campaignids="' + campaignIds + '"' : '' ), '><div class="rest-row with-image"> ');20; if (showImages) { ; buf.push('<div class="rest-row-image"> <a href="', escape((20,  profileUri )), '" target="_blank" onclick="OT.BestAnalytics.logRestaurantVisit(', escape((20, restaurant.Id)), ')"><img src="', escape((20,  photo )), '" data-src="', escape((20,  photo )), '" alt="', escape((20,  String.Format(Resources.Shared.Search.Results.AltTag, restaurant.Name).toLowerCase() )), '" class="lazy rest-image"/></a> ');20; if (experiments.shortlist === 1 ) { ; buf.push('<div class="shortlist-button-container"> ', (20,  partial('Redesign/Results/_ShortlistButton', {
              isInShortlist: false,
              isDisabled: false,
              restaurantId: restaurant.Id,
              restaurantUri: photo,
              restaurantTitle: restaurant.Name,
              reviews: reviews.Rating,
              profileUri: profileUri,
              Resources: Resources
              }) ), '</div> ');29; } ; buf.push('</div> ');29; } ; buf.push('<div class="rest-row-info"><div class="rest-row-header', escape((29,  isPromoted ? ' flex-row-justify' : '' )), '"> <a href="', escape((29,  profileUri )), '" class="rest-row-name rest-name ', escape((29,  restaurant.IsJustAdded ? 'just-added' : '' )), '" target="_blank" onclick="OT.BestAnalytics.logRestaurantVisit(', escape((29, restaurant.Id)), ')"><span class="rest-row-name-text">', (29,  (freeTextBaseCheck && restaurant.FreeText.Matches && restaurant.FreeText.Matches.Name && restaurant.FreeText.Matches.Name[0]) || restaurant.Name ), '</span> ');29; if (restaurant.IsJustAdded && !NEWLY_ADDED_RESTAURANTS_PAGE) { ; buf.push(' <span class="new-restaurant-tag">', (29,  Resources.Shared.Common.Results.JustAdded_New ), '</span> ');29; } ; buf.push(' ');29; if (dinersChoiceBaseCheck) { ; buf.push('<span class="diners-choice-badge"><span class="trophy-icon"></span> <span class="diners-choice-kind">', escape((29,  restaurant.Reviews.Awards[0].Name )), '</span></span> ');29; } ; buf.push('</a> ');29; if (isPromoted) { ; buf.push(' <span class="promoted-badge">', escape((29,  Resources.Shared.Common.Results.Promoted )), '</span> ');29; } ; buf.push('</div> ');29; if (experiments.sfx1388 == 1 ) { ; buf.push(' ');29; if (isPopTableResult) { ; buf.push('<div class="flex-row-justify"> ', (29,  partial('Redesign/Results/_Reviews', {
            Experiments: resultViewModel.Experiments,
            isPopTableResult: isPopTableResult,
            restaurant: restaurant,
            reviews: reviews,
            size: 'small',
            url: profileUri + '#reviews'
            }) ), ' ');36; if (resultViewModel.Display.ShowPrices && isPopTableResult) { ; buf.push(' ', (36,  partial('Redesign/Results/_Pricing', {
              price: restaurant.PriceBand.Id,
              experiments: resultViewModel.Experiments
              }) ), ' ');39; } ; buf.push('</div><div class="rest-row-meta rest-row-meta-grid"> ');39; if (cuisine)  { ; buf.push(' <span class="rest-row-meta--cuisine rest-row-meta-text">', (39,  cuisine ), '</span> ');39; } ; buf.push(' <span class="rest-row-meta--location rest-row-meta-text">', (39,  restaurant.Location ), '</span></div> ');39; } else if (!showDistance) { ; buf.push('<div class="rest-row-meta rest-row-meta-grid flex-row-justify"><div class="flex-row-justify"> ', (39,  partial('Redesign/Results/_Reviews', {
            Experiments: resultViewModel.Experiments,
            isPopTableResult: isPopTableResult,
            restaurant: restaurant,
            reviews: reviews,
            size: 'small',
            url: profileUri + '#reviews'
            }) ), '</div></div><div class="rest-row-meta rest-row-meta-grid flex-row-justify sfx1388flexInline"> <span class="rest-row-meta--cuisine rest-row-meta-text">');46; if (resultViewModel.Display.ShowPrices) { ; buf.push(' ', (46,  partial('Redesign/Results/_Pricing', {
              price: restaurant.PriceBand.Id,
              experiments: resultViewModel.Experiments
            }) ), ' ');49; } ; buf.push('</span> <span class="rest-row-meta--cuisine rest-row-meta-text sfx1388addContent">', (49,  cuisine ), '</span> <span class="rest-row-meta--location rest-row-meta-text sfx1388addContent">', escape((49,  restaurant.Location )), '</span></div> ');49; } else { ; buf.push('<div', (49,  showDistance ? ' class="rest-row-info--essentials"' : '' ), '><div class="rest-row-info--group"> ', (49,  partial('Redesign/Results/_Reviews', {
              Experiments: resultViewModel.Experiments,
              isPopTableResult: isPopTableResult,
              restaurant: restaurant,
              reviews: reviews,
              size: 'small',
              url: profileUri + '#reviews'
            }) ), '<div class="rest-row-meta rest-row-meta-grid rest-row--text-row rest-row-meta-grid--type"><div class="rest-row-meta rest-row-meta-grid flex-row-justify sfx1388flexInline"> <span class="rest-row-meta--cuisine rest-row-meta-text">');56; if (resultViewModel.Display.ShowPrices) { ; buf.push(' ', (56,  partial('Redesign/Results/_Pricing', {
                    price: restaurant.PriceBand.Id,
                    experiments: resultViewModel.Experiments
                  }) ), ' ');59; } ; buf.push('</span> <span class="rest-row-meta--cuisine rest-row-meta-text sfx1388addContent">', (59,  cuisine ), '</span> <span class="rest-row-meta--location rest-row-meta-text sfx1388addContent">', escape((59,  restaurant.Location )), '</span> <span class="rest-row-meta--location rest-row-meta-text sfx1388addContent">', escape((59,  milesToDisplay(restaurant.Distance, Resources.Strings.DistanceUnit_Small) )), ' ', escape((59,  Resources.Strings.DistanceUnit_Small )), '</span></div> ');59; if (resultViewModel.Display.ShowPrices && !showDistance) { ; buf.push(' ', (59,  partial('Redesign/Results/_Pricing', {
                  price: restaurant.PriceBand.Id,
                  experiments: resultViewModel.Experiments
                }) ), ' ');62; } ; buf.push('</div></div></div> ');62; } ; buf.push(' ');62; } else { ; buf.push(' ');62; if (isPopTableResult) { ; buf.push('<div class="flex-row-justify"> ', (62,  partial('Redesign/Results/_Reviews', {
            Experiments: resultViewModel.Experiments,
            isPopTableResult: isPopTableResult,
            restaurant: restaurant,
            reviews: reviews,
            size: 'small',
            url: profileUri + '#reviews'
            }) ), ' ');69; if (resultViewModel.Display.ShowPrices && isPopTableResult) { ; buf.push(' ', (69,  partial('Redesign/Results/_Pricing', {
              price: restaurant.PriceBand.Id,
              experiments: resultViewModel.Experiments
              }) ), ' ');72; } ; buf.push('</div><div class="rest-row-meta rest-row-meta-grid"> ');72; if (cuisine)  { ; buf.push(' <span class="rest-row-meta--cuisine rest-row-meta-text">', (72,  cuisine ), '</span> ');72; } ; buf.push(' <span class="rest-row-meta--location rest-row-meta-text">', (72,  restaurant.Location ), '</span></div> ');72; } else if (!showDistance) { ; buf.push('<div class="flex-row-justify"> ', (72,  partial('Redesign/Results/_Reviews', {
            Experiments: resultViewModel.Experiments,
            isPopTableResult: isPopTableResult,
            restaurant: restaurant,
            reviews: reviews,
            size: 'small',
            url: profileUri + '#reviews'
          }) ), ' ');79; if (resultViewModel.Display.ShowPrices) { ; buf.push(' ', (79,  partial('Redesign/Results/_Pricing', {
              price: restaurant.PriceBand.Id,
              experiments: resultViewModel.Experiments
            }) ), ' ');82; } ; buf.push('</div><div class="rest-row-meta rest-row-meta-grid flex-row-justify"> ');82; if (cuisine)  { ; buf.push(' <span class="rest-row-meta--cuisine rest-row-meta-text">', (82,  cuisine ), '</span> ');82; } ; buf.push(' <span class="rest-row-meta--location rest-row-meta-text">', escape((82,  restaurant.Location )), '</span></div> ');82; } else { ; buf.push('<div', (82,  showDistance ? ' class="rest-row-info--essentials"' : '' ), '><div class="rest-row-info--group"> ', (82,  partial('Redesign/Results/_Reviews', {
              Experiments: resultViewModel.Experiments,
              isPopTableResult: isPopTableResult,
              restaurant: restaurant,
              reviews: reviews,
              size: 'small',
              url: profileUri + '#reviews'
            }) ), '<div class="rest-row-meta rest-row-meta-grid rest-row--text-row rest-row-meta-grid--type"> ');89; if (resultViewModel.Display.ShowPrices && showDistance) { ; buf.push(' ', (89,  partial('Redesign/Results/_Pricing', {
                  price: restaurant.PriceBand.Id,
                  experiments: resultViewModel.Experiments
                }) ), '<span class="rest-row--text-bullet"></span> ');92; } ; buf.push(' ');92; if (cuisine)  { ; buf.push(' <span class="rest-row-meta--cuisine rest-row-meta-text">', (92,  cuisine ), '</span> ');92; } ; buf.push(' ');92; if (resultViewModel.Display.ShowPrices && !showDistance) { ; buf.push(' ', (92,  partial('Redesign/Results/_Pricing', {
                  price: restaurant.PriceBand.Id,
                  experiments: resultViewModel.Experiments
                }) ), ' ');95; } ; buf.push('</div></div><div class="rest-row-meta rest-row-meta-grid rest-row--text-row rest-row-meta-grid--distance"> <span class="rest-row-meta--location rest-row-meta-text">', escape((95,  restaurant.Location )), '</span><span class="rest-row-meta--distance rest-row-meta-text"><span class="distance-icon"></span> ', escape((95,  milesToDisplay(restaurant.Distance, Resources.Strings.DistanceUnit_Small) )), ' ', escape((95,  Resources.Strings.DistanceUnit_Small )), '</span></div></div> ');95; } ; buf.push(' ');95; } ; buf.push(' ');95; if (restaurant.IsListingsRestaurant) { ; buf.push('<div class="listings-message"> ', escape((95,  Resources.Shared.Redesign.Results.ListingsMessage )), '</div> ');95; } else if (!isPopTableResult) { ; buf.push(' ', (95,  timeslots ), ' ');95; } ; buf.push(' ');95; if (freeTextBaseCheck && lookup[restaurant.FreeText.SingleRelevanceSource]) { ; buf.push(' ', (95,  partial('Redesign/Results/_FreeTextBlurb', {
          freeTextBaseCheck: freeTextBaseCheck,
          lookup: lookup,
          restaurant: restaurant
        }) ), ' ');99; } ; buf.push(' ', (99,  partial('Redesign/Results/_TicketingDetails', {
        restaurant: restaurant,
        resultViewModel: resultViewModel,
        Resources: Resources
      }) ), ' ');103; if (restaurant.TopOffer != null && !(resultViewModel.Promo && resultViewModel.Promo.IsRestaurantWeek)) { ; buf.push('<div class="rest-row-offer', (103,  restaurant.OfferIds.length > 1 ? ' hide-more-offers' : '' ), '" data-id="', escape((103,  (restaurant.TopOffer.Id) )), '"><p class="all-offers', escape((103,  experiments.sfx1826 ? ' rest-row-offers-icon' : '' )), '"> ', escape((103,  Resources.Shared.Redesign.Strings.Label_TopOffer )), '<div class="top-offer-name offer-name">', escape((103,  restaurant.TopOffer.Name )), '</div> ');103; if (restaurant.OfferIds.length > 1) { ; buf.push('<div class="more-offers"> ');103; restaurant.Offers.forEach(function(el) { ; buf.push(' ');103; if (el.Name !== restaurant.TopOffer.Name) { ; buf.push('<div class="offer-name">', (103,  el.Name ), '</div> ');103; } ; buf.push(' ');103; }) ; buf.push('</div> ');103; } ; buf.push('</p> ');103; if (restaurant.OfferIds.length > 1) { ; buf.push('<p class="rest-row-offer-link"> ', escape((103,  Resources.Shared.Common.Results.SeeAllOffers )), '</p> <a href="', escape((103,  profileUri )), '#special-offers" target="_blank" class="rest-row-offer-link text-arrow-right">', escape((103,  Resources.Shared.Redesign.Strings.LearnMore )), '</a> ');103; } ; buf.push('</div> ');103; } ; buf.push(' ');103; if (showAffiliatedRestaurantsLink && restaurant.HasAffiliateGroup) { ; buf.push('<div class="rest-row-affiliatedlink"> <a href="/s/affiliaterestaurantlist?affiliaterestaurantid=', (103,  restaurant.Id ), '&covers=', (103,  Request.Covers ), '&datetime=', (103,  Request.DateTime ), '">', escape((103,  Resources.Shared.Redesign.Results.ViewAffiliatedRestaurantsLink )), '</a></div> ');103; } ; buf.push('</div></div> ');103; if (isPopTableResult) { ; buf.push(' ', (103,  timeslots ), ' ');103; } ; buf.push('</li>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._Result'}
,"_Pagination":{ 
  RenderView: function(locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace,
              partial: partial,
              tombstone: tombstone,
            });

            localsWithEjsMateMethods.partial = localsWithEjsMateMethods.partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var pagination = locals.pagination ; buf.push(' ');1; var showPageNumbers = locals.showPageNumbers ; buf.push(' ');1; var Html = !!locals.Html ? locals.Html : window.Html ; buf.push(' ');1; var Model = locals.Model ; buf.push(' ');1; var PageType = locals.PageType ; buf.push(' ');1; var Request = locals.Request ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var System = locals.System ; buf.push(' ');1; var block = locals.block ; buf.push(' ');1; var layout = locals.layout ; buf.push(' ');1; var partial = locals.partial ; buf.push(' ');1; var previousLink=(pagination.PaginationLinks ==null) ? '#' : (!String.IsNullOrEmpty(pagination.PaginationLinks.Previous)) ? pagination.PaginationLinks.Previous : '' ; buf.push(' ');1; var nextLink=(pagination.PaginationLinks ==null) ? '#' : (!String.IsNullOrEmpty(pagination.PaginationLinks.Next)) ? pagination.PaginationLinks.Next : '' ; buf.push('<div class="pagination-container"><ul id="results-pagination" class="pagination pagination-border"><li class="pagination-li pagination-arrow pagination-arrow-prev pagination-border-arrow-prev"> ');1; if (!String.IsNullOrEmpty(previousLink)) { ; buf.push(' <a href="', escape((1,  (previousLink) )), '" class="pagination-link pagination-prev"><span class="underline-hover">', escape((1,  Resources.Shared.Redesign.Strings.Label_Previous )), '</span></a> ');1;} else {; buf.push(' <span class="pagination-link pagination-prev pagination-unavailable"><span class="underline-hover">', escape((1,  Resources.Shared.Redesign.Strings.Label_Previous )), '</span></span> ');1; } ; buf.push('</li> ');1; if (showPageNumbers && pagination.PaginationIndex.Pages && pagination.PaginationIndex.Pages.length > 0) { ; buf.push(' ');1; pagination.PaginationIndex.Pages.forEach(function(page, pageIndex) { ; buf.push('<li class="pagination-li"> <span class="js-pagination-page ', escape((1,  ( page.From != -1 ? 'pagination-link' : '') )), ' ', escape((1,  ( page.From == -1 ? 'pagination-spacer' : '') )), ' ', escape((1,  ( page.IsCurrent ? 'pagination-current' : '') )), '" data-from="', escape((1,  (page.From) )), '"><span class="underline-hover">', (1,  page.Name ), '</span></span></li> ');1; }) ; buf.push(' ');1; } ; buf.push('<li class="pagination-li pagination-arrow pagination-arrow-next pagination-border-arrow-next"> ');1; if (!String.IsNullOrEmpty(nextLink)) { ; buf.push(' <a href="', escape((1,  (nextLink) )), '" class="pagination-link pagination-next"><span class="underline-hover">', escape((1,  Resources.Shared.Redesign.Strings.Label_Next )), '</span></a> ');1;} else {; buf.push(' <span class="pagination-link pagination-next pagination-unavailable"><span class="underline-hover">', escape((1,  Resources.Shared.Redesign.Strings.Label_Next )), '</span></span> ');1; } ; buf.push('</li></ul></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._Pagination'}
,"_AvailabilityLink":{ 
  RenderView: function(locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace,
              partial: partial,
              tombstone: tombstone,
            });

            localsWithEjsMateMethods.partial = localsWithEjsMateMethods.partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var availabilityLink = locals.availabilityLink ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; if (availabilityLink.Request.IsAvailabilityRequest && availabilityLink.Request.Availability !== 'intersperse') { ; buf.push(' ');1;
    // For personalizer, we don't have a great indicator of when to show the
    // IntersperseAvailability link, so only show it when there may be
    // unavailable results, and hide it when IntersperseAvailability is false
  ; buf.push('<p class="not-shown-message">', escape((5,  Resources.Shared.Redesign.Results.IncludeInterspercedAvailabilityText )), '</p> <a id="availability_link" class="text-arrow-right with-availability" href="javascript:void(0);"><span class="underline-hover">', escape((5,  Resources.Shared.Redesign.Results.IncludeInterspercedAvailabilityLink )), '</span></a> ');5; } ; buf.push('');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._AvailabilityLink'}
,"_NoResultsFreeText":{ 
  RenderView: function(locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace,
              partial: partial,
              tombstone: tombstone,
            });

            localsWithEjsMateMethods.partial = localsWithEjsMateMethods.partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var noResults = locals.noResults ; buf.push(' <span class="freetext-noresults-term">', escape((1,  noResults.Request.Term )), '</span>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._NoResultsFreeText'}
,"_NoResults":{ 
  RenderView: function(locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace,
              partial: partial,
              tombstone: tombstone,
            });

            localsWithEjsMateMethods.partial = localsWithEjsMateMethods.partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1;
var noResults = locals.noResults;
var clearLastFilter = locals.clearLastFilter;
var Request = locals.Request;
var Resources = !!locals.Resources ? locals.Resources : window.Resources;
var System = locals.System;
var block = locals.block;
var layout = locals.layout;
var partial = locals.partial;
var metro = noResults.Display.Metro;
var isFreeTextSearch = noResults.Request.Term;
var metroName = noResults.Display.Metro.Name || ''; // to prevent printing 'null' when no metroid is provided
; buf.push('<div class="content-section-header no-results"> ');13; if (noResults.Display.ShowDescriptionForZeroResults && !String.IsNullOrEmpty(noResults.Display.PageMetaData.Description)) { ; buf.push('<p id="page-description" class="page-description"> ', (13,  noResults.Display.PageMetaData.Description ), '</p> ');13; } ; buf.push('<h3 class="color-dark"> ', escape((13,  Resources.Shared.Redesign.NoResults.Heading )), '</h3><div class="block"><p class="no-result-message"> ');13; if (isFreeTextSearch) { ; buf.push(' ', (13, 
        String.Format(
          Resources.Shared.Search.FreeTextSearch.NoResultsMessage,
          partial('Redesign/Results/_NoResultsFreeText', { })
        )
        ), ' ');18; } ; buf.push(' ');18; if (!noResults.Results.Restaurants.length && !isFreeTextSearch) { ; buf.push(' ', escape((18,  Resources.Shared.Search.Strings.NoSearchResults_NoMatch_Message )), ' ');18; } else { ; buf.push(' ', escape((18,  Resources.Shared.Search.Strings.NoSearchResults_NoMatch_Message_Freetext )), ' ');18; } ; buf.push('</p> ');18; if (clearLastFilter) { ; buf.push(' <button id="clear_last_filter" class="button"> ', escape((18,  Resources.Shared.Search.Strings.NoSearchResults_UndoLastFilterButton )), '</button> ');18; if (!noResults.Results.Restaurants.length) { ; buf.push(' <span class="or">', escape((18,  Resources.Shared.Search.Strings.NoSearchResults_Or )), '</span> ');18; } ; buf.push(' ');18; } ; buf.push(' ');18; if (!noResults.Results.Restaurants.length || isFreeTextSearch) { ; buf.push(' <button id="start_over" class="button"> ', escape((18,  Resources.Shared.Search.Strings.NoSearchResults_StartOverButton )), '</button> ');18; } ; buf.push('</div> ');18; if (!noResults.Results.Restaurants.length) { ; buf.push('<h3 class="color-dark"> ', escape((18,  Resources.Shared.Redesign.NoResults.OtherSuggestionsHeading )), '</h3><div class="block"><div> <a href="', escape((18,  !isNaN(parseInt(noResults.Request.MetroId)) ? '/s/restaurantlist?metroid=' + noResults.Request.MetroId : '/' )), '" class="link no-results-browse-link">', escape((18,  !isNaN(parseInt(noResults.Request.MetroId)) ? String.Format(Resources.Shared.Search.Strings.NoSearchResults_MetroListLink, metroName) : '' )), '</a></div><div> <a href="', escape((18,  !isNaN(parseInt(noResults.Request.MetroId)) ? '/start/?m=' + noResults.Request.MetroId : '/' )), '" class="link">', escape((18,  String.Format(Resources.Shared.Search.Strings.NoSearchResults_MetroLink, metroName) )), '</a></div><p class="no-result-message italic"> ', escape((18,  Resources.Shared.Redesign.NoResults.OtherSuggestionsMessage )), '</p></div> ');18; } ; buf.push('</div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._NoResults'}
,"_PopTable":{ 
  RenderView: function(locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace,
              partial: partial,
              tombstone: tombstone,
            });

            localsWithEjsMateMethods.partial = localsWithEjsMateMethods.partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var popTable = locals.popTable ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push(' ');1; var block = locals.block ; buf.push(' ');1; var partial = locals.partial ; buf.push(' ');1; var experiments = popTable.Experiments ; buf.push(' ');1; var aboutPopURL = '//help.opentable.com/s/topic/0TO0c000000c8AIGAY/dining-rewards-points' 
; buf.push(' ');1; var rewardsPageURL = '//www.opentable.com/rewards' 
; buf.push(' ');1; var popTableSelector = 'poptable-results' ; buf.push(' ');1; var totalPop = popTable.Results.TotalPopAvailable ; buf.push(' ');1; if (popTable.Results.FeaturedPopRestaurants.length > 0 && (popTable.Request.OnlyPopTimes == null || popTable.Request.OnlyPopTimes == false) && (popTable.Request.OnlyUnavailable != true)) { ; buf.push('<section id="', escape((1,  popTableSelector )), '" class="', escape((1,  popTableSelector )), ' content-block with-margin"><div class="content-block-header with-border"><div class="pop-header-block"><h6 class="pop-title"> ', escape((1,  Resources.Shared.Common.Results.FeaturedPointsTitle )), '</h6> ');1; if (experiments.sfx1942 === 1 ) { ; buf.push(' <a href="', escape((1,  rewardsPageURL )), '" class="pop-about-link" data-bonus-points-url="search_about_points_loyalty_page" target="_blank">', escape((1,  Resources.Shared.Redesign.Results.AboutBonusPointRestaurants )), '<svg class="pop-about-link-icon" role="img" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>Information icon</title><g id="icon/ic_information" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><path class="pop-about-link-icon-path" d="M12 3C7.02943725 3 3 7.02943725 3 12 3 16.9705627 7.02943725 21 12 21 16.9705627 21 21 16.9705627 21 12 21 7.02943725 16.9705627 3 12 3ZM12 19C8.13400675 19 5 15.8659932 5 12 5 8.13400675 8.13400675 5 12 5 15.8659932 5 19 8.13400675 19 12 19 15.8659932 15.8659932 19 12 19ZM11.49 11C11.2138576 11 10.99 11.2238576 10.99 11.5L10.99 15.5C10.99 15.7761424 11.2138576 16 11.49 16L12.49 16C12.7661424 16 12.99 15.7761424 12.99 15.5L12.99 11.5C12.99 11.2238576 12.7661424 11 12.49 11L11.49 11ZM11.49 7.5C11.2138576 7.5 10.99 7.72385763 10.99 8L10.99 9C10.99 9.27614237 11.2138576 9.5 11.49 9.5L12.49 9.5C12.7661424 9.5 12.99 9.27614237 12.99 9L12.99 8C12.99 7.72385763 12.7661424 7.5 12.49 7.5L11.49 7.5Z" fill="none"></path></g></svg></a> ');1; } else if (experiments.sfx1942 === 0 ) { ; buf.push(' <a href="', escape((1,  aboutPopURL )), '" class="pop-about-link" data-bonus-points-url="search_about_points_faq" target="_blank">', escape((1,  Resources.Shared.Redesign.Results.AboutBonusPointRestaurants )), '</a> ');1; } else { ; buf.push(' <a href="', escape((1,  aboutPopURL )), '" class="pop-about-link" target="_blank">', escape((1,  Resources.Shared.Redesign.Results.AboutBonusPointRestaurants )), '</a> ');1; } ; buf.push('</div></div><div class="pop-result-grid analytics-results-list" data-correlationid="', escape((1,  popTable.Display.PopCorrelationId )), '"> ');1; popTable.Results.FeaturedPopRestaurants.forEach(function(restaurant, restaurantIndex) { ; buf.push(' ', (1,  partial('Redesign/Results/_Result', {
          Experiments: experiments,
          restaurant: restaurant,
          resultViewModel: popTable,
          onlyPopTimes: true,
          showImages: false,
          restaurantIndex: restaurantIndex,
          showPop: popTable.Display.ShowPop,
          isPopTableResult: true,
          correlationId: popTable.Display.PopCorrelationId,
          ignoreMarketing: false,
        }) ), ' ');12; }) ; buf.push('</div> ');12; if (popTable.Results.TotalPopAvailable > popTable.Results.FeaturedPopRestaurants.length) { ; buf.push('<div class="content-block-footer"> <a id="pop_see_all_link" class="text-arrow-right"><span class="underline-hover">', escape((12,  String.Format(Resources.Shared.Common.Results.SeeAllPopRestaurants, popTable.Results.TotalPopAvailable) )), '</span></a></div> ');12; } ; buf.push('</section> ');12; } ; buf.push('');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._PopTable'}
,"_MatchmakerBanner":{ 
  RenderView: function(locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace,
              partial: partial,
              tombstone: tombstone,
            });

            localsWithEjsMateMethods.partial = localsWithEjsMateMethods.partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var matchmakerLogo = "/s/static/images/compressed/matchmaker-logo.svg" ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push('<div class="matchmaker-banner-container"> <img src="', escape((1,  matchmakerLogo )), '" class="matchmaker-logo" alt="matchmaker logo"><div class="matchmaker-content"> ', escape((1,  (Resources.Shared.Matchmaker.MoreRecommendedResults) )), '</div></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._MatchmakerBanner'}
,"_LoadingPlaceholder":{ 
  RenderView: function(locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace,
              partial: partial,
              tombstone: tombstone,
            });

            localsWithEjsMateMethods.partial = localsWithEjsMateMethods.partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('<div class="loading-restaurant"><div class="animated-background"><div class="background-masker header-top"></div><div class="background-masker header-left"></div><div class="background-masker header-right"></div><div class="background-masker header-bottom"></div><div class="background-masker subheader-left"></div><div class="background-masker subheader-right"></div><div class="background-masker subheader-bottom"></div><div class="background-masker subheader-second-left"></div><div class="background-masker subheader-second-right"></div><div class="background-masker subheader-second-bottom"></div><div class="background-masker timeslots-left"></div><div class="background-masker timeslots-bottom"></div></div></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._LoadingPlaceholder'}
,"_ResultsTable":{ 
  RenderView: function(locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace,
              partial: partial,
              tombstone: tombstone,
            });

            localsWithEjsMateMethods.partial = localsWithEjsMateMethods.partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var resultsTable = locals.resultsTable ; buf.push(' ');1; var experiments = resultsTable.Experiments || {} ; buf.push(' ');1; var partial = locals.partial ; buf.push(' ');1; var Resources = locals.Resources || window.Resources ; buf.push(' ');1; var PageType = locals.PageType ; buf.push(' ');1; var Html = locals.Html ; buf.push(' ');1; var url = locals.url || '' ; buf.push(' ');1; var isMatchMakerQuery = (url.indexOf('isMatchMakerQuery=true') > -1) ; buf.push(' ');1; var showDistance = resultsTable.Request.IsGeoDistanceRequest ; buf.push(' ');1; 
/* Please do not remove this tombstone: */
tombstone('x-template'); 
; buf.push(' ');4; if (locals.helpers.hasAddonRestaurants(resultsTable)) { ; buf.push(' ');4; var singleSearchedRestaurant = resultsTable.Results.AddonsRestaurant.Restaurants[0] ; buf.push('<div class="content-section-header"><div class="flex-row-justify exact-header"><h3 class="results-title color-dark single-search-result"> ');4; var searchTerm = resultsTable.Request.Term || singleSearchedRestaurant.Name; ; buf.push(' ', (4,  String.Format(Resources.Shared.Redesign.Results.SingleSearchResults, '"' + searchTerm + '"') ), '</h3><div class="sort-view-filters"><div id="sort-filters" class="filter-option filter-option-sort-orders"> ', (4,  partial('Redesign/Filters/_PopupMenuFilter', {
            request: resultsTable.Request,
            showDistance: showDistance 
          })), '</div> ');7; if (!resultsTable.Request.Term) { ; buf.push('<div class="search-tab view-toggle"> ', (7,  partial('Redesign/Filters/_FilterViewOptions', {
              filterViewOptions: resultsTable
            }) ), '</div> ');9; } ; buf.push('</div></div></div><ul class="content-section-list infinite-results-list exact-match analytics-results-list" data-correlationid="', escape((9,  resultsTable.Display.RestaurantResultsCorrelationId )), '"><div class="exact-title"> ');9; var recommend = singleSearchedRestaurant.Reviews.Recommended;
         var percentRecommend = !!recommend ? Math.floor(recommend.Yes/recommend.Count * 100) : 0; ; buf.push(' ');10; if (percentRecommend >= 75) { ; buf.push(' ', escape((10,  String.Format(Resources.Strings.ExactMatch_Recommend, percentRecommend) )), ' ');10; } else { ; buf.push(' ', escape((10,  Resources.Strings.ExactMatch_Urgency )), ' ');10; } ; buf.push('</div> ');10; resultsTable.Results.AddonsRestaurant.Restaurants.forEach(function(restaurant, restaurantIndex) { ; buf.push(' ', (10,  partial('Redesign/Results/_Result', {
          Experiments: resultsTable.Experiments,
          restaurant: restaurant,
          resultViewModel: resultsTable,
          onlyPopTimes: !!resultsTable.Request.OnlyPopTimes,
          showImages: true,
          restaurantIndex: restaurantIndex,
          showPop: resultsTable.Display.ShowPop,
          isPopTableResult: false,
          showDistance: showDistance,
          ignoreMarketing: true,
          showAffiliatedRestaurantsLink: experiments.sfx348,
          correlationId: resultsTable.Display.RestaurantResultsCorrelationId
        }) ), ' ');23; }) ; buf.push('</ul> ');23; } ; buf.push(' ');23; if (isMatchMakerQuery) { ; buf.push(' ', (23,  partial('Redesign/Results/_MatchmakerBanner') ), ' ');23; } ; buf.push('<div class="content-section-header"> ');23; if (!String.IsNullOrEmpty(resultsTable.Display.Description)) { ; buf.push('<div id="page-description" class="page-description"> ', (23,  (resultsTable.Display.Description) ), '</div> ');23; } ; buf.push(' ', (23,  partial('Redesign/Results/_ResultsTitle', {
    resultsTitle: resultsTable,
    helpers: locals.helpers
  }) ), '</div> ');26; if (resultsTable.Display.ShowPop && resultsTable.Results.TotalPop && !resultsTable.Request.Term && !experiments.sfx708) { ; buf.push('<div id="search_results_pop" class="results-set results-table pop-table" data-name="PopTable"> ', (26,  partial('Redesign/Results/_PopTable', {
        popTable: resultsTable
      }) ), '</div> ');28; } ; buf.push(' ');28; if (resultsTable.Results && resultsTable.Results.Restaurants && resultsTable.Results.Restaurants.length > 0) { ; buf.push(' ', (28,  partial('Redesign/Results/_ConsumerDisclosure', {
    Resources: Resources,
    SortBy: resultsTable.Request.Sort
  }) ), '<ul class="content-section-list infinite-results-list analytics-results-list" data-correlationid="', escape((31,  resultsTable.Display.RestaurantResultsCorrelationId )), '"> ');31; if (resultsTable.Display.ShowLoadingPlaceholders) { ; buf.push(' ');31; for(var count = 0; count < 30; count++) { ; buf.push(' ', (31,  partial('Redesign/Results/_LoadingPlaceholder') ), ' ');31; } ; buf.push(' ');31; } else { ; buf.push(' ');31; resultsTable.Results.Restaurants.forEach(function(restaurant, restaurantIndex) { ; buf.push(' ', (31,  partial('Redesign/Results/_Result', {
            Experiments: resultsTable.Experiments,
            Request: resultsTable.Request,
            restaurant: restaurant,
            resultViewModel: resultsTable,
            onlyPopTimes: !!resultsTable.Request.OnlyPopTimes,
            showImages: true,
            restaurantIndex: restaurantIndex,
            showPop: resultsTable.Display.ShowPop,
            isPopTableResult: false,
            showDistance: showDistance,
            correlationId: resultsTable.Display.RestaurantResultsCorrelationId,
            ignoreMarketing: resultsTable.Display.ignoreMarketingForImpressionEvents,
          }) ), ' ');44; }) ; buf.push(' ');44; } ; buf.push('</ul> ');44; } ; buf.push(' ');44; if (resultsTable.Display.ShowPagination) { ; buf.push(' ', (44,  partial('Redesign/Results/_Pagination', {
    pagination: resultsTable.Display,
    showPageNumbers: true
  }) ), ' ');47; } ; buf.push(' ', (47,  partial('Redesign/Results/_AvailabilityLink', {
  availabilityLink: resultsTable
}) ), ' ');49; if (!String.IsNullOrEmpty(resultsTable.Display.AdditionalDetails)) { ; buf.push('<div class="promo-more-details"> ', (49,  resultsTable.Display.AdditionalDetails ), '</div> ');49; } ; buf.push('<script>\n  //TODO: Integrate this into react component during rewrite.  It toggles the .rest-row-offer-link from\n  // functionally expanding to see all offers, hiding the p.rest-row-offer-link and showing\n  // a.rest-row-offer-link which changes text from "See all specials" to "Learn More >" and links to the\n  // specials section on rest profile. Ticket: https://opentable.atlassian.net/browse/SV-2558\n  $(\'p.rest-row-offer-link\').on(\'click\', function(event) {\n    event.preventDefault();\n    $(this).closest(\'.hide-more-offers\').removeClass(\'hide-more-offers\').addClass(\'show-more-offers\');\n  });\n</script>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Results._ResultsTable'}
},"Search":{"Map":{"_ResultsList":{ 
  RenderView: function(locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace,
              partial: partial,
              tombstone: tombstone,
            });

            localsWithEjsMateMethods.partial = localsWithEjsMateMethods.partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var resultsList = locals.resultsList ; buf.push(' ');1; var experiments = resultsList.Experiments || {} ; buf.push(' ');1; var partial = locals.partial ; buf.push('<div id="map_results_list" class="results-list content-section"><ul class="content-section-list infinite-results-list analytics-results-list" data-correlationid="', escape((1,  resultsList.Display.RestaurantResultsCorrelationId )), '"> ');1; resultsList.Results.Restaurants.forEach(function(restaurant, restaurantIndex) { ; buf.push(' ', (1,  partial('Redesign/Results/_Result', {
          Experiments: experiments,
          Request: resultsList.Request,
          restaurant: restaurant,
          resultViewModel: resultsList,
          onlyPopTimes: false,
          showImages: true,
          restaurantIndex: restaurantIndex,
          showPop: resultsList.Display.ShowPop,
          correlationId: resultsList.Display.RestaurantResultsCorrelationId,
          ignoreMarketing: resultsList.Display.ignoreMarketingForImpressionEvents,
        })
      ), ' ');13; }) ; buf.push('</ul></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Search.Map._ResultsList'}
,"_ResultsMap":{ 
  RenderView: function(locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace,
              partial: partial,
              tombstone: tombstone,
            });

            localsWithEjsMateMethods.partial = localsWithEjsMateMethods.partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var resultsMap = locals.resultsMap ; buf.push(' ');1; var mapHeight = locals.desiredHeight ? 'height: ' + locals.desiredHeight + 'px;' : '' ; buf.push(' ');1; var partial = locals.partial ; buf.push(' ');1; var Resources = locals.Resources || window.Resources ; buf.push('<div class="page-main cf" style="display: ', escape((1,  resultsMap.Request.ShowMap ? 'block' : '' )), '"><div id="map" class="map-container" style="', (1, mapHeight), '"></div><div id="search" class="search-container to-map-view" style="', (1, mapHeight), '"><div class="max-width-wrapper"><div class="page-main-content"><div class="row"><div class="column no-padding"><div class="content-section-header with-border"> ', (1,  partial('Redesign/Results/_ResultsTitle', {
                resultsTitle: resultsMap
              }) ), ' ', (3,  partial('Redesign/Results/_ConsumerDisclosure', {
                Resources: Resources,
                SortBy: resultsMap.Request.Sort
              }) ), '</div><div class="map-results-scroll-container"><div class="with-padding"> ');6; if (resultsMap.Results.Total > 0) { ; buf.push(' ');6; if (resultsMap.Promo != null) { ; buf.push('<div id="single-search-modal-placeholder" class="modal"></div> ');6; } ; buf.push(' ', (6,  partial('_ResultsList', {resultsList: resultsMap}) ), ' ');6; if (resultsMap.Display.ShowPagination) { ; buf.push(' ', (6,  partial('Redesign/Results/_Pagination', {
                      pagination: resultsMap.Display,
                      showPageNumbers: true
                    }) ), ' ');9; } ; buf.push(' ', (9,  partial('Redesign/Results/_AvailabilityLink', {
                  availabilityLink: resultsMap
                  }) ), ' ');11; } else { ; buf.push(' ', (11,  partial('Redesign/Results/_NoResults', {
                    noResults: resultsMap
                  }) ), ' ');13; } ; buf.push('</div> ', (13,  partial('Common/_MapFooter', {Model: resultsMap}) ), '</div></div></div></div></div></div></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Search.Map._ResultsMap'}
,"_MapOc":{ 
  RenderView: function(locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace,
              partial: partial,
              tombstone: tombstone,
            });

            localsWithEjsMateMethods.partial = localsWithEjsMateMethods.partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var results = locals.mapOc.Results ; buf.push(' ');1; var domainCulture = locals.mapOc.DomainCulture ; buf.push(' ');1; var ocData = locals.mapOc.ocData ; buf.push('<div class="react-map-container"><oc-component class="ot-react-maps-oc" href="', escape((1,  'https://oc-registry.opentable.com/v2/ot-react-maps-oc/5.x.x' +
            '?centerLat=' + encodeURIComponent(results.Lat) +
            '&centerLng=' + encodeURIComponent(results.Long) +
            '&zoomLevel=' + encodeURIComponent(results.Zoom) +
            '&domain=' + encodeURIComponent(domainCulture.domain) +
            '&lang=' + encodeURIComponent(domainCulture.culture) +
            '&anonymousId=' + encodeURIComponent(ocData.anonymousId) +
            '&gpid=' + encodeURIComponent(ocData.gpid) )), '" data-name="ot-react-maps-oc" data-rendered="false"></oc-component></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Redesign.Search.Map._MapOc'}
}}},"Common":{"_MapFooter":{ 
  RenderView: function(locals) {
            var localsWithEjsMateMethods = _.extend(locals, {
              helpers: helpers,
              block: block,
              layout: layout,
              namespace: this.namespace,
              partial: partial,
              tombstone: tombstone,
            });

            localsWithEjsMateMethods.partial = localsWithEjsMateMethods.partial.bind(localsWithEjsMateMethods);

            return this.ejsViewFunction(localsWithEjsMateMethods);
          },
   ejsViewFunction: function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
 buf.push('');1; var model = locals.Model ; buf.push(' ');1; var Resources = !!locals.Resources ? locals.Resources : window.Resources ; buf.push('<div class="footer-container-short"><div class="footer-base"> <span class="footer-copyright">', (1,  (String.Format(Resources.Shared.Redesign.Strings.CopyrightFormat, new Date().getFullYear())) ), '</span> <a class="footer-base-link" href="/info/privacypolicy.aspx">', escape((1,  (Resources.Shared.Redesign.Strings.MapFooterLink_Privacy) )), '</a> <a class="footer-base-link" href="/info/agreement.aspx">', escape((1,  (Resources.Shared.Redesign.Strings.MapFooterLink_Terms) )), '</a></div></div>');
return buf.join('');
},
   namespace: 'Spark.Shared.Common._MapFooter'}
}}}})();